module.exports = __webpack_public_path__ + "fonts/TTNormsPro-BoldItalic.949a2960.woff2";